
import { Component, Vue } from 'vue-property-decorator';
import { OrderStage } from '@/types/order';

import OrderList from '@/components/OrderList/index.vue';
import OrderSearch from '@/components/OrderSearch/index.vue';

@Component({
  name: 'OrderCheck',
  components: {
    OrderList,
    OrderSearch
  }
})
export default class extends Vue {
  private stage = OrderStage.UNDERCHECK;
}
